import { render, staticRenderFns } from "./vip2.vue?vue&type=template&id=4e38c160&scoped=true"
import script from "./vip2.vue?vue&type=script&lang=js"
export * from "./vip2.vue?vue&type=script&lang=js"
import style0 from "./vip2.vue?vue&type=style&index=0&id=4e38c160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38c160",
  null
  
)

export default component.exports